import { SVGProps, Ref, forwardRef } from 'react';

export const VideocameraOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.405 13.697 22.2 16.07V7.929l-4.795 2.374-.33-2.493c-.235-1.779-.772-2.61-1.465-3.094-.793-.553-2.157-.916-4.61-.916H8c-2.9 0-4.261.507-4.977 1.223S1.8 7.1 1.8 10v4c0 2.9.507 4.261 1.223 4.977S5.1 20.2 8 20.2h3c2.453 0 3.817-.363 4.61-.916.693-.484 1.23-1.315 1.465-3.094zM24 6v12h-1.96l-3.18-1.574a9.4 9.4 0 0 1-.405 1.808C17.518 20.985 15.273 22 11 22H8c-6 0-8-2-8-8v-4c0-6 2-8 8-8h3c4.273 0 6.518 1.015 7.455 3.766a9.4 9.4 0 0 1 .405 1.808L22.04 6z"
                fill="currentColor"
            />
        </g>
    </svg>
));
VideocameraOutlinedSize24Glyph.displayName = 'VideocameraOutlinedSize24Glyph';
